import styled from "styled-components";
import { rgba } from "polished";
const AnchorImpl = styled("a")(
  ({ theme }) => ({
    background: "none",
    border: "none",
    borderRadius: 2,
    color: theme.color.blue6,
    cursor: "pointer",
    fontFamily: theme.fontFamily.default,
    fontWeight: theme.fontWeight.medium,
    outline: 0,
    padding: 0,
    textDecoration: "none",
    "&:hover": {
      color: theme.color.blue7
    },
    "&:active": {
      color: theme.color.blue8
    },
    "&:focus": {
      boxShadow: `0 0 0 2px ${rgba(theme.color.blue6, 0.25)}`
    }
  }),
  ({ appearance }) => ({
    plain: {
      font: "inherit",
      "&, &:hover, &:active": {
        color: "inherit"
      },
      "&:focus": {
        boxShadow: "0 0 0 2px rgba(0, 0, 0, 0.05)"
      }
    }
  })[appearance]
);
export {
  AnchorImpl
};
